import React from 'react';
import { StoreImageSpotModule } from '~/lib/data-contract';
import {
    StyledStoreImageContainer,
    StyledStoreWrapper,
} from '~/features/find-store/components/StoreMap/components/styled';
import { Image } from '~/shared/components';

type StoreImageSpotProps = StoreImageSpotModule;

export const StoreImageSpot = ({
    image,
    imageAltText,
    spacingBottom,
    spacingTop,
    border,
}: StoreImageSpotProps) => {
    if (!image) return null;
    return (
        <StyledStoreWrapper spacingBottom={spacingBottom} spacingTop={spacingTop} border={border}>
            <StyledStoreImageContainer>
                <Image {...image} layout="intrinsic" alt={imageAltText} />
            </StyledStoreImageContainer>
        </StyledStoreWrapper>
    );
};
